<template>
    <div>
        <div>
            <!-- 選択中検索条件 -->
            <!-- ID:now_head → class:search_close でサーチ選択ヘッドを格納-->
            <!-- ID:now_head → class:search_open でサーチ選択ヘッドを表示-->
            <div :class="[showSearchBar ? 'search_open' : ''] + ' now_search_head'" id="now_head" v-show="showSearchBar">

                <!-- 選択中条件詳細（検索バー）-->
                <!-- div now_search_head-->
                <div class="now_search_head___inner">
                    <div class="now_search_head___ul_wrap">
                        <ul class="now_search_head___ul">
                            <template v-if="form.fwd">
                                <li class="free_word_sp" v-on:click="focusFreeWord();">
                                    <div class="target free_word">{{ form.fwd }}</div>
                                </li>
                                <span class="pipeline">|</span>
                            </template>
                            <li>
                                <div class="target yen" v-on:click="activateTab('unit_price_type')">単価
                                    <span>{{ watchSelectedUnitPriceType(form.unp) }}</span>
                                </div>
                            </li>
                            <li>
                                <div class="target t_job" v-on:click="activateTab('job')">
                                    職種
                                    <span :class="[form.job.length <= 0 ? 'no_num' : ''] + ' num '">
                                        {{ form.job.length }}
                                    </span>
                                </div>
                            </li>
                            <li>
                                <div class="target t_skill" v-on:click="activateTab('skill')">
                                    スキル
                                    <span :class="[form.skl.length <= 0 ? 'no_num' : ''] + ' num '">
                                        {{ form.skl.length }}
                                    </span>
                                </div>
                            </li>
                            <li>
                                <div class="target t_industry" v-on:click="activateTab('industry_type')">
                                    業界
                                    <span :class="[form.ids.length <= 0 ? 'no_num' : ''] + ' num '">
                                        {{ form.ids.length }}
                                    </span>
                                </div>
                            </li>
                            <li>
                                <div class="target t_area" v-on:click="activateTab('area')">
                                    エリア
                                    <span :class="[isSelectedArea() ? '' : 'no_num'] + ' num'">
                                        {{ isSelectedArea() ? '選択中' : '未選択' }}
                                    </span>
                                </div>
                            </li>
                            <li>
                                <div class="target t_Commitment" v-on:click="activateTab('condition_type')">
                                    こだわり
                                    <span :class="[form.cdt.length <= 0 ? 'no_num' : ''] + ' num '">
                                        {{ form.cdt.length }}
                                    </span>
                                </div>
                            </li>
                            <li>
                                <div class="reset" id="tab_reset_head" v-on:click="onTabReset(true)"><span></span></div>
                            </li>
                        </ul>
                    </div>
                    <!-- 条件変更ボタン -->
                    <div class="now_search_head___button target">
                        <span>条件を変更する</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="main_inner_in">
            <!-- 案件一覧の上部 -->
            <h2 class="top_h2">案件一覧</h2>
            <div class="box_w100-75 js-now-headon">
                <div class="top_search_button" v-show="!showSearchBar">
                    <div class="target" id="m_open_search3">
                        <span>絞り込み検索をする</span>
                    </div>
                </div>

                <ul class="separate">
                    <!-- 件数 -->
                    <li class="top_number">
                        <ul>
                            <li><span class="top_number__1">{{ projects_data.total }}</span>件中</li>
                            <li><span class="top_number__2">{{ projects_data.from }}〜{{ projects_data.to }}</span>件表示中</li>
                        </ul>
                    </li>
                    <!-- ソート -->
                    <li class="top-select">
                        <select
                            name="project_sort_type"
                            v-model="sort_type"
                            v-on:change="onSearchProjects()">
                            <option
                                v-for="(value, key) in project_sort_type_name" :key="key"
                                :value="key">
                                {{ value }}
                            </option>
                        </select>
                    </li>
                </ul>
            </div>

            <!-- 案件一覧 -->
            <Projects
                :projects="projects_data"
                :cookie_expires="cookie_expires"
                :max_favorite_count="max_favorite_count"
                :price_adjustments="price_adjustments"
                :contract_types="contract_types"
                :condition_types="condition_types"
                :skill_types="skill_types"
                :projects_flg="true"
            ></Projects>
        </div>

        <!-- ページネーション -->
        <ProjectPagination
            :projects_data="projects_data"
            :paginate_link_num="paginate_link_num"
            :link_url="link_url"
        >
        </ProjectPagination>

        <!----------------- モーダル背景 ----------------->
        <div id="mask_fix" class="hidden"></div>
        <!----------------- モーダル内容 ----------------->
        <!-- モーダルボタン -->
        <form action="" name="searchform">
            <div class="modal_main">
                <div id="m_open_search_modal" :class="[show_search_modal === true ? '' : 'hidden']">
                    <div class="modal open">
                        <div class="modal_inner">
                            <p class="modal_title">絞り込み検索</p>
                            <div class="batsu modal_cancel" id="close"></div>
                            <div class="free_word_box">
                                <input
                                    type="text"
                                    maxlength="255"
                                    class="free_word_input"
                                    name="free_word"
                                    v-model="form.fwd"
                                    placeholder="フリーワード"
                                    ref="free_word">
                            </div>
                            <div class="modal_inner__in">
                                <!--タブ-->
                                <div class="tab-panel">
                                    <ul class="tab-group">
                                        <li :class="'tab tab-1' + [ active_tab === 'unit_price_type' ? ' is-active' : '' ]" v-on:click="activateTab('unit_price_type')"><span><span>単価</span></span></li>
                                        <li :class="'tab tab-2' + [ active_tab === 'job' ? ' is-active' : '' ]" v-on:click="activateTab('job')"><span><span>職種</span></span></li>
                                        <li :class="'tab tab-3' + [ active_tab === 'skill' ? ' is-active' : '' ]" v-on:click="activateTab('skill')"><span><span>スキル</span></span></li>
                                        <li :class="'tab tab-4' + [ active_tab === 'industry_type' ? ' is-active' : '' ]" v-on:click="activateTab('industry_type')"><span><span>業界</span></span></li>
                                        <li :class="'tab tab-5' + [ active_tab === 'area' ? ' is-active' : '' ]" v-on:click="activateTab('area')"><span><span>エリア</span></span></li>
                                        <li :class="'tab tab-6' + [ active_tab === 'condition_type' ? ' is-active' : '' ]" v-on:click="activateTab('condition_type')"><span><span>こだわり条件</span></span></li>
                                    </ul>
                                    <!--タブを切り替えて表示するコンテンツ-->
                                    <div class="panel-group scrollarea">
                                        <!--単価--------------------------------->
                                        <div :class="'panel tab-1' + [ active_tab === 'unit_price_type' ? ' is-show' : '']">
                                            <div class="flex_02 mb-10">
                                                <span v-for="unit_price_type in unit_price_types" :key="unit_price_type.unit_price_type_id">
                                                    <input type="radio"
                                                        :id="'salary' + unit_price_type.unit_price_type_id"
                                                        :value="unit_price_type.unit_price_type_id"
                                                        v-model="form.unp"
                                                    >
                                                    <label :for="'salary' + unit_price_type.unit_price_type_id">
                                                        <p>{{ unit_price_type.unit_price_name }}</p>
                                                    </label>
                                                </span>
                                            </div>
                                        </div>
                                        <!--職種--------------------------------->
                                        <div :class="'panel tab-2' + [ active_tab === 'job' ? ' is-show' : '']">
                                            <div class="flex_02 mb-10">
                                                <span v-for="job_type in job_types" :key="job_type.job_type_id">
                                                    <input type="checkbox"
                                                        :id="'job' + job_type.job_type_id"
                                                        :value="job_type.job_type_id"
                                                        v-model="form.job"
                                                    />
                                                    <label :for="'job' + job_type.job_type_id">
                                                        <p>{{ job_type.job_type_name }}({{ job_type.count }})</p>
                                                    </label>
                                                </span>
                                            </div>
                                        </div>
                                        <!--言語--------------------------------->
                                        <div :class="'panel tab-3' + [ active_tab === 'skill' ? ' is-show' : '']">
                                            <ul class="skill_acd">
                                                <li v-for="skill_type in skill_types" :key="skill_type.skill_type_id">
                                                    <span :id="'skill_type' + skill_type.skill_type_id" class="js_skill_acd" :ref="'skill_type_name' + skill_type.skill_type_id">{{ skill_type.skill_type_name }}({{ skill_type.count }})</span>

                                                    <div class="flex_02 mb-10" :ref="'skill_type_child' + skill_type.skill_type_id">
                                                        <template v-for="skill in skill_type.skills">
                                                            <span v-if="skill.count > 0" :key="skill.skill_id">
                                                                <input type="checkbox"
                                                                    :id="'skill' + skill_type.skill_type_id + '_'  + skill.skill_id"
                                                                    :value="skill.skill_id"
                                                                    v-model="form.skl"
                                                                />
                                                                <label :for="'skill' + skill_type.skill_type_id + '_'  + skill.skill_id">
                                                                    <p>{{ skill.skill_name }}({{ skill.count }})</p>
                                                                </label>
                                                            </span>
                                                        </template>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                        <!--業界--------------------------------->
                                        <div :class="'panel tab-4' + [ active_tab === 'industry_type' ? ' is-show' : '']">
                                            <div class="flex_02 mb-10">
                                                <span v-for="industry_type in industry_types" :key="industry_type.industry_type_id">
                                                    <input type="checkbox"
                                                        :id="'world' + industry_type.industry_type_id"
                                                        :value="industry_type.industry_type_id"
                                                        v-model="form.ids"
                                                    >
                                                    <label :for="'world' + industry_type.industry_type_id">
                                                        <p>{{ industry_type.industry_type_name }}({{ industry_type.count }})</p>
                                                    </label>
                                                </span>
                                            </div>
                                        </div>
                                        <!--エリア--------------------------------->
                                        <div :class="'panel tab-5' + [ active_tab === 'area' ? ' is-show' : '']">
                                            <ul class="skill_acd">
                                                <li v-for="prefecture in areas" :key="prefecture.prefecture_id">
                                                    <!-- アコーディオンあり -->
                                                    <template v-if="prefecture.areas.length > 0">
                                                        <span class="js_skill_acd leftline_none" :ref="'prefecture_name' + prefecture.prefecture_id">
                                                            <span class="title-in">
                                                                <span>
                                                                    <input type="checkbox"
                                                                        :id="'prefecture' + prefecture.prefecture_id"
                                                                        :value="prefecture.prefecture_id"
                                                                        v-model="form.prf"
                                                                        v-on:change="onSelectPrefecture(prefecture.prefecture_id)"
                                                                    />
                                                                    <label :for="'prefecture' + prefecture.prefecture_id">
                                                                        <p>{{ prefecture.prefecture_name }}({{ prefecture.count }})</p>
                                                                    </label>
                                                                </span>
                                                            </span>
                                                        </span>
                                                        <div class="flex_02 mb-10" :ref="'prefecture_child' + prefecture.prefecture_id">
                                                            <template v-for="area in prefecture.areas">
                                                                <!-- サブエリアあり -->
                                                                <template v-if="area.sub_areas.length > 0">
                                                                    <input type="checkbox"
                                                                        :key="area.area_id"
                                                                        :id="'area' + area.area_id"
                                                                        :value="area.area_id"
                                                                        v-model="form.mar"
                                                                        v-on:change="onSelectArea(area.area_id)"
                                                                    />
                                                                    <label :for="'area' + area.area_id">
                                                                        <p class="bold">{{ area.area_name }}({{ area.count }})</p>
                                                                    </label>
                                                                    <div class="acd_indent">
                                                                        <span v-for="sub_area in area.sub_areas" :key="sub_area.sub_area_id">
                                                                            <input type="checkbox"
                                                                                :key="sub_area.sub_area_id"
                                                                                :id="'sub_area' + sub_area.sub_area_id"
                                                                                :value="sub_area.sub_area_id"
                                                                                v-model="form.sar"
                                                                                v-on:change="onSelectSubArea(sub_area.sub_area_id)"
                                                                            />
                                                                            <label :for="'sub_area' + sub_area.sub_area_id">
                                                                                <p>{{ sub_area.sub_area_name }}({{ sub_area.count }})</p>
                                                                            </label>
                                                                        </span>
                                                                    </div>
                                                                </template>
                                                                <!-- サブエリアなし -->
                                                                <template v-else-if="area.sub_areas.length <= 0">
                                                                    <span :key="area.area_id">
                                                                        <input type="checkbox"
                                                                            :id="'area' + area.area_id"
                                                                            :value="area.area_id"
                                                                            v-model="form.mar"
                                                                            v-on:change="onSelectArea(area.area_id)"
                                                                        />
                                                                        <label :for="'area' + area.area_id">
                                                                            <p class="bold">{{ area.area_name }}({{ area.count }})</p>
                                                                        </label>
                                                                    </span>
                                                                </template>
                                                            </template>
                                                        </div>
                                                    </template>
                                                    <!-- アコーディオンなし -->
                                                    <template v-else-if="prefecture.areas.length <= 0">
                                                        <span class="no_skill_acd leftline_none">
                                                            <span class="title-in">
                                                                <span>
                                                                    <input type="checkbox"
                                                                        :id="'prefecture' + prefecture.prefecture_id"
                                                                        :value="prefecture.prefecture_id"
                                                                        v-model="form.prf"
                                                                        v-on:change="onSelectPrefecture(prefecture.prefecture_id)"
                                                                    />
                                                                    <label :for="'prefecture' + prefecture.prefecture_id">
                                                                        <p>{{ prefecture.prefecture_name }}({{ prefecture.count }})</p>
                                                                    </label>
                                                                </span>
                                                            </span>
                                                        </span>
                                                    </template>
                                                </li>
                                            </ul>
                                        </div>
                                        <!--こだわり条件--------------------------------->
                                        <div :class="'panel tab-6' + [ active_tab === 'condition_type' ? ' is-show' : '']">
                                            <div class="flex_02 mb-10">
                                                <span v-for="condition_type in condition_types" :key="condition_type.condition_type_id">
                                                    <input type="checkbox"
                                                        :id="'kodawari' + condition_type.condition_type_id"
                                                        :value="condition_type.condition_type_id"
                                                        v-model="form.cdt"
                                                    />
                                                    <label :for="'kodawari' + condition_type.condition_type_id">
                                                        <p>{{ condition_type.condition_type_name }}({{ condition_type.count }})</p>
                                                    </label>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- 下部ボタン群 -->
                                <div class="modal_bottom">
                                    <ul>
                                        <li>
                                            <p id="tab_reset" v-on:click="onTabReset()">全件リセットする</p>
                                        </li>
                                        <li>
                                            <input type="submit" value="検索する" v-on:click.prevent="onSearchProjects()">
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>

        <ul class="right_nav right_nav__none" id="js-right_nav">
            <li>
                <!-- 追従検索 -->
                <div class="right_nav__search">
                    <div class="target" id="m_open_search2"><span>検索</span></div>
                </div>
            </li>
            <li>
                <!-- 追従ページトップへ -->
                <div class="right_nav__totop">
                    <a href="#js_main"><span>TOP</span></a>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
    import Projects from '../base/Projects.vue';
    import modal from '../../util/04_modal_single.js';
    import jsSkillAcd from '../../util/03_js_skill_acd'; // モーダル内のアコーディオン
    import pageInScroll from '../../util/05_page_in_scroll'; // モーダル内のアコーディオン
    import JSONbig from 'json-bigint';
    import ProjectPagination from './ProjectPagination';

    export default {
        components: {
            Projects,
            ProjectPagination
        },

        props: {
            'projects': Object,
            'unit_price_types': Array,
            'job_types_data': Array,
            'skills_data': Array,
            'industry_types_data': Array,
            'areas_data': Array, // エリア・サブエリアがリレーションされている都道府県
            'condition_types_data': Array,
            'max_favorite_count': Number, // 最大お気に入り登録数
            'price_adjustments': Object,  // 単価調整率
            'contract_types': Object,    // 契約形態コード
            'cookie_expires': Number,  // クッキーの期限
            'project_sort_type': Object, // ソートタイプ
            'project_sort_type_name': Object, // ソート順名
            'paginate_link_num': Number, // 最大ページネーション表示数
            'search_category_code': Object, // カテゴリーコード一覧
            'condition': Object, // query_parameter
            'is_form_empty': Boolean, // formが空で全件検索の場合
            'cat_code': String, // urlのcategory_code
            'cat_id': Number, // urlのcategory_id
            'project_url': String, // 全件検索url
        },

        data() {
            return {
                projects_data: {},
                projects_length: 0,
                show_search_modal: false,
                form: {
                    unp: 7,  // unit_price
                    job: [], // job
                    skl: [], // skill
                    ids: [], // industry
                    prf: [], // prefecture
                    mar: [], // area
                    sar: [], // sub_area
                    cdt: [], // condition
                    fwd: ''
                },
                sort_type: this.project_sort_type['new'], // ソート順
                showSearchBar: false,
                job_types: [],
                skill_types: [],
                industry_types: [],
                areas: [],
                condition_types: [],
                link_url: '',
                active_tab: 'unit_price_type', // モーダル内の、アクティブなタブ
            }
        },

        created() {
            // projectsデータをセット
            this.projects_data = this.projects;
            this.projects_length = this.projects_data.length;

            // あらかじめ案件ゼロの各カテゴリを除外
            this.excludeProjectsCountZero(this.areas_data);

            // URLのクエリパラメータをフォームにセット　※検索バー・モーダルにも反映
            this.setGetParameter();

            // ページネーション用のリンクURLをセット
            this.link_url = this.setLinkUrl();

            // 全件検索かどうか
            if (!this.is_form_empty) {
                this.showSearchBar = true;
            }
        },

        mounted() {
            // jsファイルの読み込み
            modal(); // モーダルの開閉のみ
            jsSkillAcd(); // モーダル内のスキル・エリアのアコーディオン
            pageInScroll(); // トップスクロールの動き
            // 検索メニューがある場合は、高さを保持
            this.addMarginTopForMenu();
            // 値に合わせてスキルのアコーディオンを開く
            this.setSkillAccordion();
            // 値に合わせてエリアのアコーディオンを開く
            this.setAreaAccordion();

        },

        methods: {
/************************
 * 初期処理
 ************************/
            // 文字列のproject_idを,bigintに変換
            parseStringToBigInt: function(projects)
            {
                return projects.map((project) => {
                    project.project_id = JSONbig.parse(project.project_id);
                    return project
                })
            },

            // カテゴリの案件ゼロを除外　※JS側のロジックに合わせるため
            excludeProjectsCountZero: function()
            {
                this.job_types = this.excludeCategoryProjectsCountZero(this.job_types_data);
                this.skill_types = this.excludeSkillTypeProjectsCountZero(this.skills_data);
                this.industry_types = this.excludeCategoryProjectsCountZero(this.industry_types_data);
                this.areas = this.excludeAreaProjectsCountZero(this.areas_data);
                this.condition_types = this.excludeCategoryProjectsCountZero(this.condition_types_data);
            },

            // カテゴリの案件ゼロを除外　※JS側のロジックに合わせるため
            excludeCategoryProjectsCountZero: function(category_data)
            {
                return category_data.filter((category) => category.count > 0);
            },

            // スキルの案件ゼロを除外　※JS側のロジックに合わせるため
            excludeSkillTypeProjectsCountZero: function(skills_data)
            {
                return skills_data.flatMap((skill_type) => {
                    if (skill_type.count > 0) {
                        skill_type.skills = skill_type.skills.filter((skill) => skill.count > 0);
                        return skill_type;
                    }
                    return [];
                })
            },

            // エリアの案件ゼロを除外　※JS側のロジックに合わせるため
            excludeAreaProjectsCountZero: function(areas_data)
            {
                return areas_data.flatMap((pref) => {
                    if (pref.count > 0) {
                        pref.areas = pref.areas.flatMap((area) => {
                            if (area.count > 0) {
                                area.sub_areas = area.sub_areas.filter((sub_area) => sub_area.count > 0);
                                return area;
                            }
                            return [];
                        })
                        return pref;
                    }
                    return [];
                })
            },
/************************
 * 共通
 ************************/
            // タブを全てリセット searchの値がtrueならば、そのまま全検索　※モーダルでも使用
            onTabReset: function(search = false)
            {
                Object.keys(this.form).forEach((key) =>{
                    if (key === this.search_category_code['unit_price']) {
                        this.form[key] = '7';
                    } else if (key === this.search_category_code['free_word']) {
                        this.form[key] = '';
                    } else {
                        this.form[key] = [];
                    }
                })

                if (search) {
                    this.onSearchProjects();
                }
            },

            // 検索クエリをセットして、遷移
            onSearchProjects: function()
            {
                let params = {};
                // 各種パラメータのキー名を変更し、セット
                Object.keys(this.form).forEach((key) => {
                    // 空白のみで検索した場合の対策として、全角スペース（%E3%80%80）を半角スペース(%20)に変換
                    params[key] = encodeURIComponent(this.form[key]).replace(/%E3%80%80/g, '%20');
                });
                params['sort'] = Number(this.sort_type); // ソート順
                params['page'] = 1; // ページネーションのページ番号

                const url = this.setQueryParameter(params);

                location.href = url;
            },

            //パラメータを設定したURLを返す
            setQueryParameter: function ( paramsArray )
            {
                let res_url = this.project_url;

                Object.keys(paramsArray).forEach((key) => {
                    if (paramsArray[key] != '') {
                        res_url += (res_url.indexOf('?') == -1) ? '?':'&';
                        res_url += key + '=' + paramsArray[key];
                    }
                })

                return res_url;
            },

/************************
 *  検索バー
 ************************/
            // 検索メニューがある場合は、高さを保持
            addMarginTopForMenu: function()
            {
                var open = document.getElementsByClassName("search_open");

                if (open[0]) {
                    if (window.innerWidth < 800) {
                        var H = open[0].clientHeight
                        document.getElementsByClassName("js-now-headon")[0].style.marginTop =
                            H + "px"
                    }
                }
            },

            // 選択された単価を監視
            watchSelectedUnitPriceType: function(unit_price_type)
            {
                let current_unit_price_type = this.unit_price_types.filter((item) => item.unit_price_type_id == unit_price_type);
                return current_unit_price_type.length ? current_unit_price_type[0].unit_price_name : '指定なし';
            },

            // モーダルのエリアを選択しているかどうか
            isSelectedArea: function() {
                return (this.form.prf.length > 0) || (this.form.mar.length > 0) || (this.form.sar.length > 0);
            },

/************************
 * ページネーション
 ************************/
            // リンクをセット
            setLinkUrl: function()
            {
                let params = {};
                // 各種パラメータのキー名を変更し、セット
                Object.keys(this.form).forEach((key) => {
                    params[key] = encodeURIComponent(this.form[key]);
                });
                params['sort'] = Number(this.sort_type); // ソート順

                return this.setQueryParameter(params);
            },

/************************
 * モーダル
 ************************/
            // 選択したタブを有効にする
            activateTab: function(category_name) {
                this.active_tab = category_name;
            },
            // フリーワードの入力欄をフォーカスする
            focusFreeWord: function() {
                this.$refs.free_word.focus();
            },
            // URLのクエリパラメータをフォームにセット　※検索バー・モーダルにも反映
            setGetParameter: function()
            {
                // クエリパラメーターの内容をフォームにセット
                Object.keys(this.form).forEach((key) => {
                    // 単体検索の場合
                    this.searchBySingleCategory(key);

                    // 複数検索の場合
                    this.searchByMultiCategories(key);
                });

                // ソート順
                this.sort_type = typeof this.condition['sort'] != "undefined" ? this.condition['sort'] : this.project_sort_type['new'];
            },

            // 単体検索の場合 例：/projects/job/1
            searchBySingleCategory: function(key)
            {
                if (this.cat_code && key === this.cat_code) {
                    // 値をフォームにセット
                    this.form[key] = [this.cat_id];

                    // 存在しているカテゴリかどうかfilter
                    switch (this.cat_code) {
                        case this.search_category_code['job']: {
                            this.form[key] = this.form[key].filter((job_type_id) => this.job_types.some((job_type) => job_type.job_type_id === job_type_id));
                            break;
                        }
                        case this.search_category_code['industry']: {
                            this.form[key] = this.form[key].filter((industry_type_id) => this.industry_types.some((industry_type) => industry_type.industry_type_id === industry_type_id));
                            break;
                        }
                        case this.search_category_code['condition']: {
                            this.form[key] = this.form[key].filter((condition_type_id) => this.condition_types.some((condition_type) => condition_type.condition_type_id === condition_type_id));
                            break;
                        }
                        case this.search_category_code['skill']: {
                            this.form[key] = this.form[key].filter((skill_id) => this.skill_types.some((skill_type) => skill_type.skills.some((skill) => skill.skill_id === skill_id)));
                            break;
                        }
                        // 上下層のエリアのチェックをセット
                        case this.search_category_code['prefecture']: {
                            const prefectures = this.areas.filter((pref) => pref.prefecture_id === this.cat_id);

                            // エリアを全チェック
                            this.form[this.search_category_code['area']] = [...this.form[this.search_category_code['area']], ...prefectures[0].areas.map((area) => area.area_id)];

                            // サブエリアを全チェック
                            prefectures[0].areas.forEach((area) => {
                                this.form[this.search_category_code['sub_area']] = [...this.form[this.search_category_code['sub_area']], ...area.sub_areas.map((sub_area) => sub_area.sub_area_id)];
                            });
                            break;
                        }
                        case this.search_category_code['area']: {
                            const prefecture = this.areas.filter((pref) => pref.areas.some((area) => area.area_id === this.cat_id));

                            const area = prefecture[0].areas.filter((area) => area.area_id === this.cat_id);

                            this.form[this.search_category_code['sub_area']] = [...this.form[this.search_category_code['sub_area']], ...area[0].sub_areas.map((sub_area) => sub_area.sub_area_id)];

                            // エリアが１件の場合は、全チェックとなるため、上層都道府県もチェック
                            const areas = prefecture[0].areas.filter((area) => area.count != 0); // 案件０件
                            if (areas.length === 1) {
                                this.form[this.search_category_code['prefecture']].push(prefecture[0].prefecture_id);
                            }
                            break;
                        }
                        case this.search_category_code['sub_area']: {
                            const prefecture = this.areas.filter((pref) => pref.areas.some((area) => area.sub_areas.some((sub_area) => sub_area.sub_area_id === this.cat_id)));

                            // サブエリアが１件の場合は、全チェックとなるため、上層エリアもチェック
                            if (prefecture[0].areas[0].sub_areas.length === 1) {
                                this.form[this.search_category_code['area']].push(prefecture[0].areas[0].area_id);

                                // エリアが１件の場合は、全チェックとなるため、上層都道府県もチェック
                                if (prefecture[0].areas.length === 1) {
                                    this.form[this.search_category_code['prefecture']].push(prefecture[0].prefecture_id);
                                }
                            }
                            break;
                        }
                    }
                }
            },

            // 複数検索の場合 例：/projects?unp=7&job=3&skl=1&sort=1&page=1
            searchByMultiCategories: function(key)
            {
                if (!this.cat_code) {
                    Object.keys(this.condition).forEach((condition_key) => {
                        if (key === condition_key) {
                            // 存在しているカテゴリかどうかfilter
                            switch (key) {
                                case this.search_category_code['unit_price']: {
                                    this.form[key] = this.condition[key];
                                    break;
                                }
                                case this.search_category_code['job']: {
                                    this.form[key] = this.condition[key].filter((job_type_id) => this.job_types.some((job_type) => job_type.job_type_id === job_type_id));
                                    break;
                                }
                                case this.search_category_code['industry']: {
                                    this.form[key] = this.condition[key].filter((industry_type_id) => this.industry_types.some((industry_type) => industry_type.industry_type_id === industry_type_id));
                                    break;
                                }
                                case this.search_category_code['condition']: {
                                    this.form[key] = this.condition[key].filter((condition_type_id) => this.condition_types.some((condition_type) => condition_type.condition_type_id === condition_type_id));
                                    break;
                                }
                                case this.search_category_code['skill']: {
                                    this.form[key] = this.condition[key].filter((skill_id) => this.skill_types.some((skill_type) => skill_type.skills.some((skill) => skill.skill_id === skill_id)));
                                    break;
                                }
                                // 上下層のエリアのチェックもセット
                                case this.search_category_code['prefecture']: {
                                    this.form[key] = this.condition[key].filter((pref_id) => this.areas.some((pref) => pref.prefecture_id === pref_id));
                                    const prefectures = this.areas.filter((pref) => this.form[key].some((pref_id) => pref_id === pref.prefecture_id));

                                    prefectures.forEach((pref) => {
                                        // エリアを全チェック
                                        this.form[this.search_category_code['area']] = [...this.form[this.search_category_code['area']], ...pref.areas.map((area) => area.area_id)];

                                        // サブエリアを全チェック
                                        pref.areas.forEach((area) => {
                                            this.form[this.search_category_code['sub_area']] = [...this.form[this.search_category_code['sub_area']], ...area.sub_areas.map((sub_area) => sub_area.sub_area_id)];
                                        });
                                    });

                                    // idの重複削除
                                    this.excludeDuplicatedId();

                                    break;
                                }
                                case this.search_category_code['area']: {
                                    this.form[key] = this.condition[key].filter((area_id) => this.areas.some((pref) => pref.areas.some((area) => area.area_id === area_id)));
                                    const prefectures = this.areas.filter((pref) => pref.areas.some((area) => this.form[key].some((area_id) => area_id === area.area_id)));

                                    prefectures.forEach((pref) => {
                                        const areas = pref.areas.filter((area) => this.form[key].some((area_id) => area_id === area.area_id));

                                        areas.forEach((area) => {
                                            this.form[this.search_category_code['sub_area']] = [...this.form[this.search_category_code['sub_area']], ...area.sub_areas.map((sub_area) => sub_area.sub_area_id)];
                                        });

                                        // エリアが１件の場合は、全チェックとなるため、上層都道府県もチェック
                                        if (pref.areas.length === 1) {
                                            this.form[this.search_category_code['prefecture']].push(pref.prefecture_id);
                                        }
                                    });

                                    // idの重複削除
                                    this.excludeDuplicatedId();

                                    break;
                                }
                                case this.search_category_code['sub_area']: {
                                    this.form[key] = this.condition[key].filter((sub_area_id) => this.areas.some((pref) => pref.areas.some((area) => area.sub_areas.some((sub_area) => sub_area.sub_area_id === sub_area_id))));
                                    const prefectures = this.areas.filter((pref) => pref.areas.some((area) => area.sub_areas.some((sub_area) => this.form[key].some((sub_area_id) => sub_area_id === sub_area.sub_area_id))));

                                    prefectures.forEach((pref) => {
                                        pref.areas.forEach((area) => {
                                            // サブエリアが１件の場合は、全チェックとなるため、上層エリアもチェック
                                            if (area.sub_areas.length === 1) {
                                                this.form[this.search_category_code['area']].push(area.area_id);
                                            }
                                        })

                                        // エリアが１件の場合は、全チェックとなるため、上層都道府県もチェック
                                        if (pref.areas.length === 1) {
                                            this.form[this.search_category_code['prefecture']].push(pref.prefecture_id);
                                        }
                                    });

                                    // idの重複削除
                                    this.excludeDuplicatedId();

                                    break;
                                }
                                case this.search_category_code['free_word']: {
                                    this.form[key] = this.condition[key];
                                    break;
                                }
                            }
                        }
                    });
                }
            },

            // エリアのidの重複削除
            excludeDuplicatedId() {
                this.form[this.search_category_code['prefecture']] = [...new Set(this.form[this.search_category_code['prefecture']])];
                this.form[this.search_category_code['area']] = [...new Set(this.form[this.search_category_code['area']])];
                this.form[this.search_category_code['sub_area']] = [...new Set(this.form[this.search_category_code['sub_area']])];
            },

            // 各スキルの値にあわせて、スキルタイプのアコーディオンを開く
            setSkillAccordion: function()
            {
                // スキルがあった場合の、親スキルのアコーディオンを開く
                if (this.form.skl.length > 0) {
                    this.form.skl.forEach((skill_id)=> {
                        const skill_type = this.skill_types.filter((skill_type) => skill_type.skills.some((skill) => skill.skill_id === skill_id));
                        this.openSkillAccordion(skill_type);
                    })
                }
            },

            // 各エリアの値にあわせて、都道府県アコーディオンを開く
            setAreaAccordion: function()
            {
                // エリアがあった場合の、都道府県アコーディオンを開く
                if (this.form.mar.length > 0) {
                    this.form.mar.forEach((area_id)=> {
                        // エリアの都道府県情報を取得
                        const prefecture = this.areas.filter((pref) => pref.areas.some((area) => area.area_id === area_id));
                        this.openAreaAccordion(prefecture);
                    })
                }
                // サブエリアがあった場合の、都道府県アコーディオンを開く
                if (this.form.sar.length > 0) {
                    this.form.sar.forEach((sub_area_id)=> {
                        // サブエリアの都道府県情報を取得
                        const prefecture = this.areas.filter((pref) => pref.areas.some((area) => area.sub_areas.some((sub_area) => sub_area.sub_area_id === sub_area_id)));
                        this.openAreaAccordion(prefecture);
                    })
                }
            },

            // モーダル内のスキルのアコーディオンを開く
            openSkillAccordion: function(skill_type)
            {
                const skill_type_name = this.$refs['skill_type_name' + skill_type[0].skill_type_id];
                const skill_type_child = this.$refs['skill_type_child' + skill_type[0].skill_type_id];
                skill_type_name[0].classList.add("is-active");
                skill_type_child[0].classList.add("is-open");
            },

            // モーダル内のエリアのアコーディオンを開く
            openAreaAccordion: function(prefecture)
            {
                const prefecture_name = this.$refs['prefecture_name' + prefecture[0].prefecture_id];
                const prefecture_child = this.$refs['prefecture_child' + prefecture[0].prefecture_id];
                prefecture_name[0].classList.add("is-active");
                prefecture_child[0].classList.add("is-open");
            },

            // 都道府県選択時に、所属する全エリア・全サブエリアにチェックを反映
            onSelectPrefecture: function(prefecture_id)
            {
                // 選択した都道府県と、その配下のエリアの情報を取得
                const prefecture = this.areas.filter((prefecture) => prefecture.prefecture_id === prefecture_id);

                // 都道府県がチェック済みの場合
                if(this.form.prf.includes(prefecture_id)) {
                    // 配下のエリアを全件チェック
                    for (const area of prefecture[0].areas) {
                        this.form.mar.push(area.area_id);

                        // 配下のサブエリアを全件チェック
                        for (const sub_area of area.sub_areas) {
                            this.form.sar.push(sub_area.sub_area_id);
                        }

                        this.form.sar = [...new Set(this.form.sar)]; // idの重複削除
                    }

                    this.form.mar = [...new Set(this.form.mar)]; // idの重複削除
                // 都道府県が未チェックの場合
                } else {
                    // 配下のエリアを全件削除
                    for (const area of prefecture[0].areas) {
                        this.form.mar = this.form.mar.filter((form_area_id) => form_area_id != area.area_id);

                        // 配下のサブエリアを削除
                        for (const sub_area of area.sub_areas) {
                            this.form.sar = this.form.sar.filter((form_sub_area_id) => form_sub_area_id != sub_area.sub_area_id);
                        }
                    }
                }
            },

            // エリア選択に、所属する都道府県・または全サブエリアにチェックを反映
            onSelectArea: function(area_id)
            {
                // 選択した都道府県と、その配下のエリアの情報を取得
                const prefecture = this.areas.filter((prefecture) => prefecture.areas.some((area) => area.area_id === area_id));
                // 選択したエリアの情報と、その配下のサブエリアの情報を取得
                const current_areas = prefecture[0].areas.filter((area) => this.form.mar.includes(area.area_id));

                // エリアがチェック済みの場合
                if(this.form.mar.includes(area_id)) {
                    // 配下のサブエリアを全件削除
                    for (const area of prefecture[0].areas) {
                        if (area.area_id === area_id) {
                            for (const sub_area of area.sub_areas) {
                                this.form.sar.push(sub_area.sub_area_id);
                            }

                            this.form.sar = [...new Set(this.form.sar)]; // idの重複削除
                        }
                    }

                    // 親の都道府県配下のエリアが、全件チェック済みの場合
                    if (prefecture[0].areas.length === current_areas.length) {
                        this.form.prf.push(prefecture[0].prefecture_id);
                        this.form.prf = [...new Set(this.form.prf)]; // idの重複削除
                    }

                // エリアが未チェックの場合
                } else {
                    // 配下のエリアを全件チェック
                    for (const area of prefecture[0].areas) {
                        if (area.area_id === area_id) {
                            for (const sub_area of area.sub_areas) {
                                this.form.sar = this.form.sar.filter((form_sub_area_id) => form_sub_area_id != sub_area.sub_area_id);
                            }
                        }
                    }

                    // 親の都道府県配下のエリアの未チェックが、あとひとつだけだった場合
                    if ((prefecture[0].areas.length - 1) === current_areas.length) {
                        this.form.prf = this.form.prf.filter((form_prefecture_id) => form_prefecture_id != prefecture[0].prefecture_id);
                    }
                }
            },

            // サブエリア選択
            onSelectSubArea: function(sub_area_id)
            {
                // 選択したサブエリアの都道府県と、その配下の全てのエリア・サブエリアの情報を取得
                const prefecture = this.areas.filter((prefecture) => prefecture.areas.some((area) => area.sub_areas.some((sub_area) => sub_area.sub_area_id === sub_area_id)));
                // 選択したサブエリアのエリアと、その配下の全てのサブエリアの情報を取得
                const area = prefecture[0].areas.filter((area) => area.sub_areas.some((sub_area) => sub_area.sub_area_id == sub_area_id));
                // 選択したサブエリアの都道府県の、全てのエリアとサブエリアの情報を取得
                const current_areas = prefecture[0].areas.filter((area) => this.form.mar.includes(area.area_id));
                // 選択したサブエリアのエリアの、全てのサブエリアの情報を取得
                const current_sub_areas = area[0].sub_areas.filter((sub_area) => this.form.sar.includes(sub_area.sub_area_id));

                // サブエリアがチェック済みの場合
                if (this.form.sar.includes(sub_area_id)) {
                    // 親のエリア配下のサブエリアが全件チェック済みの場合
                    if (area[0].sub_areas.length === current_sub_areas.length) {
                        current_areas.push(area[0].area_id)
                        this.form.mar.push(area[0].area_id);
                        this.form.mar = [...new Set(this.form.mar)]; // idの重複削除
                    }

                    // 親の都道府県配下のサブエリアが全件チェック済みの場合
                    if (prefecture[0].areas.length === current_areas.length) {
                        this.form.prf.push(prefecture[0].prefecture_id);
                        this.form.prf = [...new Set(this.form.prf)]; // idの重複削除
                    }
                // サブエリアが未チェックの場合
                } else {
                    // 親のエリア配下のサブエリアが未チェックが、あとひとつだけだった場合
                    if ((area[0].sub_areas.length - 1) === current_sub_areas.length ) {
                        this.form.mar = this.form.mar.filter((form_area_id) => form_area_id != area[0].area_id);
                    }

                    // 親の都道府県配下のエリアの未チェックが、あとひとつだけだった場合
                    if ((prefecture[0].areas.length) === current_areas.length) {
                        this.form.prf = this.form.prf.filter((form_prefecture_id) => form_prefecture_id != prefecture[0].prefecture_id);
                    }
                }
            },
        }
    }
</script>
